import type { MenuItem, TagId, TagConfig } from 'src/types/types';
import { TagList } from 'src/components/TagList/TagList';
import { getSalePrice } from 'src/utils/getSalePrice';

import styles from './styles.module.scss';
import { withImageKitTransform } from 'src/utils/imageTransform';
import { CARD_IMAGE_TRANSFORM } from 'src/constants/layout';

type CardItemProps = {
  item: MenuItem;
  tagConfig: Record<TagId, TagConfig>;
  priority?: boolean;
};

export const CardItem = ({
  item,
  tagConfig,
  priority = false,
}: CardItemProps) => {
  const hasSale = item.discount !== undefined && item.discount > 0;
  const salePrice = hasSale ? getSalePrice(item.price, item.discount!) : null;
  const imgSrc = item.image
    ? withImageKitTransform(item.image, CARD_IMAGE_TRANSFORM)
    : '';

  return (
    <li className={styles.card}>
      <div className={styles.accent} />
      <div className={styles.body}>
        {imgSrc && (
          <div className={styles.imgWrapper}>
            <img
              src={imgSrc}
              alt={item.name}
              loading={priority ? 'eager' : 'lazy'}
              fetchPriority={priority ? 'high' : 'auto'}
              className={styles.img}
              width={122}
              height={122}
            />
          </div>
        )}
        <div className={styles.wrapper}>
          <div>
            <div className={styles.top}>
              <div className={styles.nameRow}>
                <span className={styles.name}>{item.name}</span>
                <TagList tags={item.tags} config={tagConfig} />
              </div>
            </div>
            {item.description && (
              <p className={styles.description}>{item.description}</p>
            )}
          </div>
          <div className={styles.footer}>
            <div className={styles.priceBlock}>
              {hasSale ? (
                <>
                  <span className={styles.priceOld}>{item.price}₴</span>
                  <span className={styles.priceSale}>{salePrice}₴</span>
                </>
              ) : (
                <span className={styles.price}>{item.price}₴</span>
              )}
            </div>
            {item.weight && (
              <>
                <span className={styles.divider} />
                <p className={styles.weight}>{item.weight}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};
